import { errors } from "com";
import { PREFERENCES_ENDPOINTS } from "./endpoints";
import type { SavePreferencesPayload, UserPreferences } from "./types";
import { apiRequestWithData } from "../shared";

const { ValidationError } = errors;

export default async function savePreferences(preferences: SavePreferencesPayload): Promise<UserPreferences> {
  if (!preferences || typeof preferences !== "object") {
    throw new ValidationError("Preferences must be an object");
  }

  return apiRequestWithData<UserPreferences>(PREFERENCES_ENDPOINTS.SAVE, {
    method: "POST",
    body: JSON.stringify(preferences),
  });
}
